export default function validate(values, message = '') {
  const { registrationId } = values;

  return {
    registrationId: !registrationId && 'ID Registrasi Harus diisi' || message,
  };
}
